import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SafeDatePipe } from "./safe-date.pipe";
import {
  MatInputModule,
  MatAutocompleteModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDialogModule,
  MatTabsModule
} from "@angular/material";

// import * as $ from 'jquery';

// Import angular-fusioncharts
import { FusionChartsModule } from "angular-fusioncharts";

// Import FusionCharts library and chart modules
import * as FusionCharts from "fusioncharts";
import * as Charts from "fusioncharts/fusioncharts.charts";

// For Powercharts , Widgets, and Maps
// import * as PowerCharts from 'fusioncharts/fusioncharts.powercharts';
import * as Widgets from "fusioncharts/fusioncharts.widgets";
// import * as Maps from 'fusioncharts/fusioncharts.maps';
// To know more about suites,
// read this https://www.fusioncharts.com/dev/getting-started/plain-javascript/install-using-plain-javascript

// For Map definition files
// import * as World from 'fusioncharts/maps/fusioncharts.world';
import * as FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Pass the fusioncharts library and chart modules
FusionChartsModule.fcRoot(FusionCharts, Charts, Widgets, FusionTheme);
// FusionChartsModule.fcRoot(FusionCharts, Charts, FusionTheme);

import { GaugeChartsComponent } from "./charts/gauge-charts/gauge-charts.component";
import { PieChartsComponent } from "./charts/pie-charts/pie-charts.component";
import { LineChartComponent } from "./charts/line-chart/line-chart.component";
import { BubbleChartComponent } from "./charts/bubble-chart/bubble-chart.component";
import { ScatterChartComponent } from "./charts/scatter-chart/scatter-chart.component";
import { MsLineChartComponent } from "./charts/msline-chart/msline-chart.component";

import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";
import { MobileVerifyComponent } from "./mobile-verify/mobile-verify.component";
import { MobileVerifyFormComponent } from "./mobile-verify/mobile-verify-form.component";
import { BenefitsPlansComponent } from "./benefits-plans/benefits-plans.component";

import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { LoaderComponent } from "./loader/loader.component";

import { CustomCurrencyPipe } from "./custom-currency.pipe";
import { CustomNumberPipe } from "./custom-number.pipe";
import { CustomDatePipe } from "./custom-date.pipe";
import { StarRatingComponent } from "./star-rating/star-rating.component";
import { LoginRegisterModule } from "../authentication/login-register/login-register.module";

import { AddClientFormComponent } from "./partner/add-client-form.component";

@NgModule({
  declarations: [
    MobileVerifyComponent,
    MobileVerifyFormComponent,
    ConfirmDialogComponent,
    BenefitsPlansComponent,
    GaugeChartsComponent,
    PieChartsComponent,
    LineChartComponent,
    MsLineChartComponent,
    BubbleChartComponent,
    ScatterChartComponent,
    CustomCurrencyPipe,
    CustomNumberPipe,
    CustomDatePipe,
    StarRatingComponent,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    AddClientFormComponent,
    SafeDatePipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FusionChartsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatDialogModule,
    LoginRegisterModule
  ],
  exports: [
    CustomCurrencyPipe,
    CustomNumberPipe,
    CustomDatePipe,
    MobileVerifyComponent,
    MobileVerifyFormComponent,
    AddClientFormComponent,
    ConfirmDialogComponent,
    BenefitsPlansComponent,
    GaugeChartsComponent,
    PieChartsComponent,
    BubbleChartComponent,
    ScatterChartComponent,
    LineChartComponent,
    MsLineChartComponent,
    StarRatingComponent,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    SafeDatePipe
  ]
})
export class SharedModule {}
